import React, { useState, useEffect } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Onboarding from '../../pages/onboarding/OnBoarding';

export default function EditProfileDialog({
  open,
  handleClose,
  userRole,
  userToEdit,
  setUserToEdit,
  userToken,
  queryClient,
}) {
  const [edifierToEditData, setEdifierToEditData] = useState(null);

  useEffect(() => {
    if (userToEdit && open) {
      // Prepare the user data for editing
      // The OnBoarding component expects basic fields at top level and additional info in info object
      const editData = {
        _id: userToEdit.id,
        fname: userToEdit.fname,
        lname: userToEdit.lname,
        email: userToEdit.email,
        phone: userToEdit.phone,
        gender: userToEdit.gender,
        role: userToEdit.role?.toLowerCase() === 'coach' ? 'coach' : 'teacher',
        schoolId: userToEdit.schoolId,
        // Include all info fields that might be in the form
        info: {
          ...userToEdit.info,
          // Ensure all possible form fields are included
          currentStatus: userToEdit.info?.currentStatus,
          totalTeachingExperience: userToEdit.info?.totalTeachingExperience,
          city: userToEdit.info?.city,
          state: userToEdit.info?.state,
          contentSpeciality: userToEdit.info?.contentSpeciality,
          languagesSpoken: userToEdit.info?.languagesSpoken,
          encouragementAdvice: userToEdit.info?.encouragementAdvice,
          brief: userToEdit.info?.brief,
          accolades: userToEdit.info?.accolades,
          districtSchool: userToEdit.info?.districtSchool,
          gradeCurrentlyTeaching: userToEdit.info?.gradeCurrentlyTeaching,
          programType: userToEdit.info?.programType,
          institutionType: userToEdit.info?.institutionType,
          ethnoracially: userToEdit.info?.ethnoracially,
          teachingStatus: userToEdit.info?.teachingStatus,
          location: userToEdit.info?.location,
          expertiesAndResources: userToEdit.info?.expertiesAndResources,
          // Add any other fields that might be in the form
          ...userToEdit.info
        }
      };
      setEdifierToEditData(editData);
    }
  }, [userToEdit, open]);

  const handleDialogClose = (e) => {
    setEdifierToEditData(null);
    handleClose(e);
  };

  return (

    <Dialog
      open={open}
      fullWidth
      maxWidth="xl"
      onClose={handleDialogClose}
      aria-labelledby="edit-profile-dialog-title"
      aria-describedby="edit-profile-dialog-description"
      sx={{
        '& .MuiPaper-root': {
          height: 'max-content',
          borderRadius: '20px',
          minWidth: { xs: '100%', md: 'fit-content' },
        },
      }}
    >
      <DialogContent sx={{ p: { xs: '0 !important', sm: 'inherit' }, bgcolor: 'background.paper', color: 'text.primary' }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', p: '20px' }}>
          <Typography variant="h4" sx={{ color: 'text.titles' }}>
            Edit Profile
          </Typography>
          <CloseIcon sx={{ cursor: 'pointer' }} onClick={handleDialogClose} />
        </Box>

        {edifierToEditData && (
          <Onboarding
            key={`edit-${edifierToEditData._id}-${Date.now()}`}
            handleClose={handleDialogClose}
            userRole={userRole}
            edifierToEditData={edifierToEditData}
            setEdifierToEditData={setUserToEdit}
            userToken={userToken}
            isOnlyEdifier={userRole === 'coach'}
            queryClient={queryClient}
          />
        )}
      </DialogContent>
    </Dialog>
  );
}
